import { Component, OnInit, OnDestroy, HostListener, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { unByKey } from 'ol/Observable';

import { Map, View } from 'ol';
import { ContentAttachPayload } from '../content-creator/add-content/models/content.model';
import { OSM, ImageWMS } from 'ol/source';
import { Image as ImageLayer, Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { defaults as defaultcontrol } from 'ol/control';
import { MultiPolygon, Point } from 'ol/geom';
import { Draw } from 'ol/interaction';
import Feature from 'ol/Feature';
import * as turf from '@turf/turf';
import VectorSource from 'ol/source/Vector.js';
import {
  wmsurl,
  workspace,
  stateboundary,
  river,
  route,
  layerlist,
  background,
  borders,
  grid,
  burgs,
  mapstyle,
} from '../../constant/maplayers';
import { applyRememberedMapLayer, rememberMapLayer } from 'src/app/constant/map-layer-memory';
import Crop from 'ol-ext/filter/Crop';
import { isTerrainReady, TerrainInfo } from 'src/app/services/terrain-layer';
import { applyTerrainLook, mountTerrain } from 'src/app/services/terrain-mount';
import { addTerrainPaintingNotice, exportMapImage } from 'src/app/services/terrain-decor';
import { setLabelsFogArea } from 'src/app/services/terrain-labels';
import { MapMarkersController } from 'src/app/services/map-markers';
import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT.js';
import { ScaleLine } from 'ol/control.js';

import { mapcenter, serviceurl, DEFAULT_ZOOM, BURG_LAYER_MIN_ZOOM, BURG_LAYER_MAX_ZOOM, WORLD_TUMBLER_URL, elevationRanges, biomeRanges } from '../../constant/constant';

import {
  Fill,
  Circle as CircleStyle,
  Stroke,
  Style,
  Text,
  Icon,
} from 'ol/style.js';
import { DataService } from 'src/app/services/data.service';
import { MapService } from 'src/app/services/map.service';
import { ContentCreatorModalDetailComponent } from '../content-creator/content-creator-modal-detail/content-creator-modal-detail.component';
import { InfoBarMapViewService } from 'src/app/services/info-bar-map-view.service';
import { CellDetails } from 'src/app/models/cell-details.model';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { forkJoin } from 'rxjs';
import { MapDataService } from 'src/app/services/map-data.service';
import { WikiService } from 'src/app/services/wiki.service';
import { ContentData } from '../content-creator/add-content/models/content.model';
import { PlaceContentModalComponent } from 'src/app/modal/place-content-modal/place-content-modal.component';
import { ToastService } from 'src/app/services/toast.service';
import { StoreLinkService } from 'src/app/services/marketplace/store-link.service';
import { applyGround, ASSUMED_GROUND, ground, groundOf, ladderView, oldOverviewZoom, overview } from 'src/app/services/zoom-ladder';


@Component({
    selector: 'app-main-component',
    templateUrl: './main-component.component.html',
    styleUrls: ['./main-component.component.css', '../mapview/map-screen.shared.scss'],
    standalone: false
})
export class MainComponentComponent implements OnInit, OnDestroy {
  map: Map;
  map1: any;
  osm: any;
  mapid: any;
  fltrFeatures: any = [];
  foglayer: any;
  stateboundary = stateboundary;
  borders = borders;
  river = river;
  route = route;
  grid = grid;
  burgs = burgs;
  boundaryfeat: any;

  layerlist = layerlist;
  background = background;
  vectorSorce: any;
  VectorLayer: any;
  draw: any;
  view: any;
  imagecrop: any;
  cropfeature: any;
  /*** */
  riverCrop: any;
  routeCrop: any;
  labelCrop: any;
  stateCrop: any;
  borderCrop: any;
  gridCrop: any;

  riverCropFeat: any;
  routeCropFeat: any;
  labelCropFeat: any;
  stateCropFeat: any;
  borderCropFeat: any;
  gridCropFeat: any;
  /** */
  isCollapsed: boolean = true;
  mapareaheight = '100px';
  mapareawidth = '100px';
  Circleradius: any = 5;
  viewparam: any;
  isdisplay_city: boolean = false;
  /**
   *
   * @param event state data
   */
  /***
   * Vector Data Loading
   */
  stateVectorSource;
  stateVectorLayer;
  BordersVectorSource;
  BordersVectorLayer;
  vectorlayerList: any = [];
  wmslayerList: any = [];
  hasTerrain = false; // baked terrain is shown in place of the GeoServer look
  private terrainWaitTimer: any = null; // while a new map's terrain is being made
  private terrainNotice: any = null;
  terrainTowns: any = null; // TownsController: town plans at true scale
  terrainClimateBars: any = null; // ClimateBarsController: bottom-of-screen temperature/rainfall readout
  exportingPicture = false;
  markers: MapMarkersController | null = null;
  canAddMarker = false;
  menuPosition: { x: number; y: number } = { x: 0, y: 0 };
  showMenu: boolean = false;
  newCoordinates: any[] = [];

  /***
   * JSON Object for dynamic handling
   */
  cityvectorSorce: any;
  cityVectorLayer: any;
  drawenabled: boolean = false;
  sideInfoBar: boolean = false;
  objectData: any;
  cultureData: any;
  windowmapheight: string = '123px';
  contentCreatorData: ContentData[] = [];
  contentCreatorDataMap: any[] = [];
  layerContentPinLayer: VectorLayer<VectorSource> | undefined;
  contentPinsClickKey: any;

  isCultureVisible: boolean = true;
  isMapDetailsVisible: boolean = false;
  map_name: string = '';
  currentLayerName: string = 'state';
  arrayOfLayerNames: any = [
    'foglayer',
    'border',
    'rivers',
    'burgs',
    'routes',
    'miltary',
    'grid',
    'cells',
  ];
  legendData: any = [];
  cityData: any;
  isDisplayCityMap: boolean = false;
  cityBackRoute: string = '';
  isCityDetailsVisible: boolean = false;
  newLayers: any[];
  cellDetailsOrder: string[] = [
    'City Present',
    'Elevation',
    'Depth',
    'Population',
    'State',
    'Province',
    'Culture',
    'Religion',
    'Biome',
    'Land Area',
    'Geozone',
    'Natural Resources',
    'Bonus Resources',
    'Farm Resources',
    'Mineral Resources',
    'Special Resources',
  ];

  cityDetailsSortArray: string[] = [
    'City Name',
    'Population',
    'District',
    'Capitol',
    'Port',
    'Citadel',
    'City Walls',
    'Market Place',
    'Religious Center',
    'Shanty Town',
  ];

  isSidebarCollapsed = false;

  isSidebarClosed = false;
  isLayerPanelCollapsed = false;
  userId: string | number | undefined;
  coordsArrOfPointsUser: { coords: [number, number][], idArr: number[], content: ContentData[] } = { coords: [], idArr: [], content: [] };
  coordsArrOfPointsPlayer: { coords: [number, number][], idArr: number[], content: ContentData[] } = { coords: [], idArr: [], content: [] };
  currentLayerWikiName: string = 'state';
  elevationRanges: string[] = elevationRanges
  biomeRanges: string[] = biomeRanges
  isLoading: boolean = false;
  redirect_coords: string | null = null;

  constructor(
    private DataService: DataService,
    public activeroute: ActivatedRoute,
    private mapService: MapService,
    private infoBarService: InfoBarMapViewService,
    private dataService: DataService,
    private storeLinks: StoreLinkService,
    private router: Router,
    private currentUserService: CurrentUserService,
    private modalService: NgbModal,
    private mapDataService: MapDataService,
    private wikiService: WikiService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) { }
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    // The map fills the window below the app header (no site footer here).
    // Measured from the header, not the map's own position: arriving from a
    // scrolled page (e.g. the Maps list) made that position, and so the map
    // height, wrong.
    const headerHeight = document.querySelector('app-header')?.getBoundingClientRect().height || 48;
    this.windowmapheight = Math.max(320, window.innerHeight - headerHeight) + 'px';
  }

  toggleSidebar(layer: string) {
    this.sidebarState[layer] = !this.sidebarState[layer];
  }

  // ... other component logic

  sidebarState: { [key: string]: boolean } = {};
  toggleSettings() {
    // Implement logic for handling settings click
    // You can open/close a modal, navigate to a settings page, etc.
  }
  resetLayers() {
    // open on the layer last chosen for this map (e.g. after Create new
    // content -> Back), otherwise State
    this.currentLayerName = applyRememberedMapLayer(this.activeroute.snapshot.paramMap.get('map_id'));
  }

  toggleLayerPanel() {
    this.isLayerPanelCollapsed = !this.isLayerPanelCollapsed;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.onResize();
    window.dispatchEvent(new Event('resize'));
    this.resetLayers();
    this.mapid = this.activeroute.snapshot.paramMap.get('map_id');
    this.viewparam = 'mapcode:' + this.mapid;
    this.intializeInformationSubscription();
    this.getMapName();
    this.getLegendDataLocal(this.mapid, this.currentLayerName);
  }
  private getMapName(): void {
    this.mapService.mapList$.subscribe({
      next: (data) => {
        if (data) {

          this.map_name = data.find((map) => map.map_id == this.mapid)?.map_name;
          this.cdr.detectChanges();
        }
        else {
          this.mapService.getMapList()
        }

      },
      error: (error) => {
        console.error('Error fetching map list:', error);
      
          this.cdr.detectChanges();}
    })
  }

  getLegendDataLocal(mapcode: string, layer_name: string) {
    this.dataService
      .getLegendData(mapcode, layer_name)
      .subscribe((data: { res: any[] }) => {
        if (data.res.length > 0) {
          this.legendData = data.res;
          this.processLegendData(this.legendData);
        } else {
          this.legendData = [];
        }
        this.cdr.detectChanges();
      });
  }

  processLegendData(legendData: any) {
    this.legendData = legendData.map((ele) => ({
      name: ele.name,
      full_name: ele.full_name,
      color: ele.color,
    }));

  }
  private intializeInformationSubscription() {
    this.infoBarService.dataRetriver$.subscribe((data) => {
      if (!data) return;

      // According to the new InfoBarMapViewService, data = { resource_values, burg_values }
      const cell = data.resource_values;
      const burg = data.burg_values;
      if (!this.map_name && cell?.map_name) {
        this.map_name = cell.map_name;
      }

      // CELL DETAILS (right panel)
      this.objectData = {
        'City Present': burg ? 'Yes' : 'None',
        Culture: cell.culture,
        Religion: cell.religion,
        State: cell.state,
        Province: cell.province,
        Biome: cell.biome,
        Elevation: cell.elevation + ' ft' || 'NA',
        Depth: cell.depth + ' ft' || 'NA',
        Population: cell.population,
        'Natural Resources': cell.basic_resources,
        'Bonus Resources': cell.bonus_resources,
        'Mineral Resources': cell.mineral_resources,
        'Farm Resources': cell.farm_resources,
        'Special Resources': cell.special_resources,
      };
            if (this.objectData.Elevation === 'undefined ft' || this.objectData.Elevation === '0 ft') {
        delete this.objectData.Elevation;
      }
      if (this.objectData.Depth === 'undefined ft' || this.objectData.Depth === '0 ft') {
        delete this.objectData.Depth;
      }

      // CITY DETAILS (left panel)
      if (burg) {
        this.cityData = {
          'City Name': burg.burg || burg.Burg,
          Capitol: burg.capital || burg.Capital || 'No',
          Citadel: burg.citadel || burg.Citadel || 'No',
          Port: burg.port || burg.Port || 'No',
          'Market Place': burg.Plaza || 'No',
          'City Walls': burg.walls || burg.Walls || 'No',
          'Religious Center':
            burg.Temple && burg.Temple.length > 0 ? 'Yes' : 'No',
          'Shanty Town':
            burg['Shanty Town'] && burg['Shanty Town'].length > 0
              ? 'Yes'
              : 'No',
          Population: burg.population || burg.Population || cell.population,
        };
        this.isCityDetailsVisible = true;
        this.isMapDetailsVisible = true;
      } else {
        this.cityData = null;
        this.isCityDetailsVisible = false;
        this.isMapDetailsVisible = true;
      }
      this.cdr.detectChanges();
    });
  }

  cellDetailsSort = (a: any, b: any): number => {
    const order = this.cellDetailsOrder;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  cityDetailsSort = (a: any, b: any): number => {
    const order = this.cityDetailsSortArray;
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);
    // If not found, put at the end
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  };

  ngAfterViewInit() {
    this.activatedRoute.queryParams.subscribe((params) => {

      if (params['redirect_coords'] && params['redirect_coords'] != 'null' && params['redirect_coords'] != 'undefined') {
        this.redirect_coords = params['redirect_coords'];
      }
      this.loadmap(this.redirect_coords);
    
          this.cdr.detectChanges();});
  }
  bactTomap() { }
  loadmap(redirect_coords: string) {
    // on the zoom ladder from the start (Guia's scale until the map's own arrives, see addTerrain)
    this.view = ladderView(ASSUMED_GROUND, mapcenter, undefined, overview(DEFAULT_ZOOM, ASSUMED_GROUND));
    this.osm = new TileLayer({
      preload: Infinity,
      source: new OSM(),
    });
    this.vectorSorce = new VectorSource();
    this.VectorLayer = new VectorLayer({
      source: this.vectorSorce,
    });

    this.layerlist.forEach((lyr) => {
      if (lyr.name === 'burgs') {
        this.addVectorLayer(lyr);
      } else this.addImageLayer(lyr);
    });

    this.map = new Map({
      target: 'map',
      layers: [
        ...this.wmslayerList, //,
        this.VectorLayer, //vector,this.stateVectorLayer,
      ],
      view: this.view,
      controls: defaultcontrol({
        attribution: false,
        zoom: false,
      }),
    });
    this.addTerrain();
    this.markers = new MapMarkersController(this.map, this.dataService, this.mapid, null,
      (message, kind) => this.toastService.showNote(message, kind || 'note'));
    this.markers.onAccess = (access) => {
      this.canAddMarker = access.can_add_world;
      this.cdr.detectChanges();
    };
    const scalebar = new ScaleLine({
      units: 'metric',
      bar: true,
      steps: 5,
      text: false,
      minWidth: 140,
    });
    this.map.addControl(scalebar);
    this.currentUserService.currentUser.subscribe({
      next: (user) => {
        this.userId = user.id;
        this.getAllRecords();
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error fetching user data:', err);
      
          this.cdr.detectChanges();},
    });

    this.getBoundary(redirect_coords);
    this.map.on('singleclick', (evt) => {
      if (this.markers?.hitAt(evt.pixel)) return; // a marker click shows the marker, not the cell
      var feature = this.map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        return feature;
      });

      if (feature && !this.drawenabled && feature.getProperties()?.['burg_id']) {
        sessionStorage.setItem('cityVisitZoom', this.view.getZoom().toString());
        sessionStorage.setItem('cityVisitLon', this.view.getCenter()[0].toString());
        sessionStorage.setItem('cityVisitLat', this.view.getCenter()[1].toString());

        this.router.navigate(
          [
            'city-map-view',
            feature.getProperties()['burg_id'],
            this.mapid,
            'null',
            'null',
          ],
          { queryParams: { token: 'hi', isLoadToken: false, backRoute: 'map' } }
        );
      }

      this.DataService.getCustomCellData({
        longitude: evt.coordinate[0],
        latitude: evt.coordinate[1],
        map_code: this.mapid,
      }).subscribe((data: CellDetails) => {
        const resourceObj = this.processResourceObjectToPass(data);
        if (data && data.burg_id) {
          this.infoBarService.setNewInfo({
            resource_values: resourceObj,
            burg_values: data.burgs_data,
          });
        } else {
          this.infoBarService.setNewInfo({
            resource_values: resourceObj,
            burg_values: null,
          });
        }
        this.cdr.detectChanges();
      });
    });
    this.map.on('pointermove', (evt) => {
      var hit = this.map.forEachFeatureAtPixel(
        evt.pixel,
        function (feature, layer) {
          return true;
        }
      );
      this.map.getViewport().style.cursor = hit ? 'pointer' : '';
    });

    setTimeout(() => {
      this.map.updateSize();
    }, 2000);
    this.loadcharacters();
    if (this.redirect_coords) {
      this.zoomToRedirectCoordsMain(this.redirect_coords);
    }
  }
  loadcharacters() {
  }

  onRightClickPopup(event: MouseEvent) {
    event.preventDefault(); // Prevent the default context menu

    // keep the menu on screen near the right/bottom edges
    this.menuPosition.x = Math.min(event.clientX, window.innerWidth - 260);
    this.menuPosition.y = Math.min(event.clientY, window.innerHeight - 200);

    this.showMenu = true;
    this.cdr.detectChanges();

    this.newCoordinates = this.map.getEventCoordinate(event) as [
      number,
      number
    ];
  }

  openPlaceContentModal() {
    this.showMenu = false;
    const modalRef = this.modalService.open(PlaceContentModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
    });

    modalRef.result.then((selectedContent: ContentData) => {
      if (selectedContent) {
        const payload: ContentAttachPayload = {
          wp_product_id: selectedContent.wp_product_id,
          content_id: selectedContent.id,
          wp_user_id: Number(this.userId),
          context: 'map' as const,
          map_id: String(this.mapid),
          city_id: null,
          latitude: this.newCoordinates[0],
          longitude: this.newCoordinates[1],
          label: selectedContent.content_title
        };

        this.isLoading = true;
        this.cdr.detectChanges();
        this.dataService.contentAttach(payload).subscribe({
          next: () => {
            this.isLoading = false;
            this.toastService.showSuccess('Content placed.', 'success');
            this.getAllRecords(); // Refresh pins
            this.cdr.detectChanges();
          },
          error: (err) => {
            this.isLoading = false;
            console.error('Error attaching content:', err);
            this.toastService.showSuccess("We couldn't place this content. Please try again.", 'danger');
            this.cdr.detectChanges();
          },
        });
      }
    });
  }

  createContent() {
    this.isLoading = true;
    this.cdr.detectChanges();
    forkJoin({
      cellData: this.dataService.getCustomCellData({
        latitude: this.newCoordinates[1],
        longitude: this.newCoordinates[0],
        map_code: this.mapid,
      }),
      mapGenre: this.dataService.getMapGenre(this.mapid)
    }).subscribe({
      next: (result: any) => {
        this.isLoading = false;
        this.cdr.detectChanges();
        const data = result.cellData;
        const genreData = result.mapGenre;

        if (data) {
          const elevationRanges = this.buildElevationRange(data);
          const biomeRanges = this.processBiomeRanges(data);
          const zoom = this.map.getView().getZoom() ?? 0;
          sessionStorage.setItem('contentCreationZoom', zoom.toString());
          sessionStorage.setItem('contentCreationLat', this.newCoordinates[1].toString());
          sessionStorage.setItem('contentCreationLon', this.newCoordinates[0].toString());

          const payload: any = {
            biome: biomeRanges,
            elevation: elevationRanges,
          };

          if (genreData?.res) {
            payload.game_genre = genreData.res;
          }
          if (genreData?.game_system) {
            payload.game_system = genreData.game_system;
          }

          this.passFinalObjectToContentPage(payload);
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.cdr.detectChanges();
        console.error(err);
      }
    });
  }

  private contentPinStyleFn(iconName: string) {
    return (feature: Feature, resolution: number) => {
      const zoom = oldOverviewZoom(resolution, groundOf(this.map)); // thresholds tuned on Guia's old zooms

      // adjust scale based on zoom
      let scale = 0.08;

      if (zoom >= 5 && zoom < 7) scale = 0.10;
      else if (zoom >= 7 && zoom < 9) scale = 0.12;
      else if (zoom >= 9 && zoom < 11) scale = 0.14;
      else if (zoom >= 11) scale = 0.18;

      return new Style({
        image: new Icon({
          src: `assets/icons/${iconName}`,
          scale,
          anchor: [0.5, 1],
        }),
      });
    };
  }

  passFinalObjectToContentPage(queryParamsObject: any) {
    this.mapDataService.setContentRangesData(queryParamsObject);
    this.router.navigate(['/add-edit-content'], {
      queryParams: {
        map_id: this.mapid,
        character_id: 23,
        backwordNavigate: this.router.url,
        coordinates: this.newCoordinates?.join(','),
      },
    });
  }

  buildElevationRange(data: any) {
    const elevation = data?.elevation > 0 ? data.elevation : data?.depth ?? NaN;


    // Always build the base object first
    const result: Record<string, boolean> = this.elevationRanges.reduce(
      (acc, range) => {
        acc[range] = false;
        return acc;
      },
      {} as Record<string, boolean>
    );

    // Explicit early return for invalid elevation
    if (typeof elevation !== 'number' || Number.isNaN(elevation)) {
      return result;
    }

    for (const range of this.elevationRanges) {
      const match = range.match(/-?\d+/g);
      if (!match || match.length < 2) continue;

      const min = Number(match[0]);
      const max = Number(match[1]);

      if (elevation >= min && elevation <= max) {
        result[range] = true;
        break;
      }
    }

    return result;
  }

  processBiomeRanges(data: any) {
    let biome: string = data?.biome ?? '';

    // Normalize input biome to Title Case
    biome = biome
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    // Build base result object (all false)
    const result: Record<string, boolean> = this.biomeRanges.reduce(
      (acc, range) => {
        acc[range] = false;
        return acc;
      },
      {} as Record<string, boolean>
    );

    // If biome is empty or invalid, return all false
    if (!biome) {
      return result;
    }

    // Exact match → set true
    if (result.hasOwnProperty(biome)) {
      result[biome] = true;
    }

    return result;
  }
  getAllRecords() {
    forkJoin({
      contentCreator: this.dataService.getContentDataByMapId(
        this.userId,
        this.mapid
      ),
      mapContentCreator: this.dataService.getContentDataOfPlayersByMapCode(
        this.mapid
      ), // <-- your 2nd API here
    }).subscribe(
      (result: {
        contentCreator: { results: ContentData[] };
        mapContentCreator: { res: any[] };
      }) => {
        if (result.contentCreator) {
          this.contentCreatorData = result.contentCreator.results;
          this.coordsArrOfPointsUser = this.extractCoordinatesFromPins(
            this.contentCreatorData,
          );

          // Perform your action with the data
          this.addStaticPoint(
            false,
            this.coordsArrOfPointsUser,
            false,
          );
          this.cdr.detectChanges();

          if (result.mapContentCreator.res) {
            // Do something with the second API result
            this.contentCreatorDataMap = result.mapContentCreator.res;
            this.contentCreatorDataMap = this.contentCreatorDataMap.filter(
              (ele) => ele.user_id !== this.userId
            );
            // this.coordsArrOfPointsPlayer = this.contentCreatorDataMap.map(
            //   (ele) => ele.coordslocationarr
            // );
            // this.addStaticPoint(
            //   false,
            //   this.coordsArrOfPointsPlayer,
            //   true,
            //   this.contentCreatorDataMap
            // );
          }
        }

        // Or combine both results in some logic
        // ...
      }
    );
  }

  private extractCoordinatesFromPins(contentData: ContentData[]): { coords: [number, number][], idArr: number[], content: ContentData[] } {
    const coords: [number, number][] = [];
    const idArr: number[] = [];
    const content: ContentData[] = [];
    (contentData || [])
      .filter((ele) => ele.pins && ele.pins.length > 0)
      .forEach((ele) => {
        ele.pins
          .filter((pin) => String(pin.map_id) === String(this.mapid) && !pin.city_id)
          .forEach((pin) => {
            coords.push([
              parseFloat(pin.latitude as any),
              parseFloat(pin.longitude as any),
            ]);
            idArr.push(pin.id);
            content.push(ele);
          });
      });
    return { coords, idArr, content };
  }

  addStaticPoint(
    isForceClear: boolean,
    coordsArr: { coords: [number, number][], idArr: number[], content: ContentData[] },
    isRed: boolean,
    onFeatureClick?: (data: any, feature: any) => void
  ) {
    if (!this.layerContentPinLayer) {
      this.layerContentPinLayer = new VectorLayer({
        source: new VectorSource(),
        minZoom: overview(6, groundOf(this.map)),
        zIndex: 99,
      });
      this.map.addLayer(this.layerContentPinLayer);
    } else if (this.layerContentPinLayer && isForceClear) {
      this.layerContentPinLayer.getSource().clear();
      this.map.removeLayer(this.layerContentPinLayer);
      this.map.addLayer(this.layerContentPinLayer);
    }

    for (let idx = 0; idx < coordsArr.coords.length; idx++) {
      let coords = coordsArr.coords[idx] as [number, number];
      const featureData = coordsArr.content[idx];
      const firstWord = featureData.type?.split(' ')[0]
      const iconName = firstWord?.toLowerCase() + '_content_icon.png' || 'one_content_icon.png'

      var feature = new Feature({
        geometry: new Point(coords),
      });

      feature.setStyle(this.contentPinStyleFn(iconName));
      if (coordsArr.content && coordsArr.content.length > idx) {
        const featureDataConst = {
          ...coordsArr.content[idx],
          wp_usage_id: coordsArr.idArr[idx],
        };
        feature.set('contentData', featureDataConst);
      }
      this.layerContentPinLayer.getSource().addFeature(feature);
    }

    // click handler
    if (onFeatureClick) {
      if (this.contentPinsClickKey) {
        unByKey(this.contentPinsClickKey);
      }
      const handler = (evt) => {
        const hit = this.map.forEachFeatureAtPixel(evt.pixel, (feat, layer) =>
          layer === this.layerContentPinLayer ? feat : null
        );
        if (hit) {
          const data = hit.get && hit.get('contentData');
          onFeatureClick(data, hit);
        }
      };
      this.contentPinsClickKey = this.map.on('singleclick', handler);
    } else {
      if (this.contentPinsClickKey) {
        unByKey(this.contentPinsClickKey);
      }
      const handler = (evt) => {
        const hit = this.map.forEachFeatureAtPixel(evt.pixel, (feat, layer) =>
          layer === this.layerContentPinLayer ? feat : null
        );
        if (hit) {
          const data = hit.get && hit.get('contentData');
          const modalRef = this.modalService.open(
            ContentCreatorModalDetailComponent,
            {
              size: 'lg',
              backdrop: 'static',
            }
          );
          (modalRef.componentInstance as any).data = data ?? {};
          (modalRef.componentInstance as any).feature = hit;
        }
      };
      this.contentPinsClickKey = this.map.on('singleclick', handler);
    }
  }

  processResourceObjectToPass(data: CellDetails) {
    // Build the resource object for the CELL DETAILS panel (no burg info)
    const resourceObj = {
      map_name: data.map_name,
      culture: data.culture,
      religion: data.religion,
      state: data.state,
      province: data.province,
      biome: data.biome,
      elevation: data.elevation,
      population: data.population,
      depth: data.depth,
      basic_resources: data.resources?.basic || [],
      bonus_resources: data.resources?.bonus || [],
      farm_resources: data.resources?.farmed || [],
      mineral_resources: data.resources?.mineral || [],
      special_resources: data.resources?.special || [],
    };
    // You can now use resourceObj as needed (e.g., pass to info bar, etc.)
    return resourceObj;
  }


  private addVectorLayer(lyr: any): void {
    const source = new VectorSource();
    const burgLayer = new VectorLayer({
      maxZoom: ground(BURG_LAYER_MAX_ZOOM),
      minZoom: overview(BURG_LAYER_MIN_ZOOM, groundOf(this.map)),
      properties: lyr,
      opacity: lyr.opacity,
      source: source,
      style: (feature, resolution) => {
        const prop: any = feature.getProperties();
        const name = prop.burg;
        const currentzoom = oldOverviewZoom(resolution, groundOf(this.map)); // tuned on Guia's old zooms
        return currentzoom < 6
          ? new Style({
            image: new Icon({
              scale: 0.15,
              src: 'assets/icons/city.png',
            }),
          })
          : new Style({
            image: new Icon({
              scale: 0.3,
              src: 'assets/icons/city.png',
            }),
            text: new Text({
              textAlign: 'center',
              font: currentzoom + 10 + 'px',
              text: name,
              fill: new Fill({ color: '#272727' }),
              stroke: new Stroke({ color: 'white', width: 3 }),
              offsetX: 0,
              offsetY: -30,
            }),
          });
      },
    });
    burgLayer.setZIndex(1000);
    this.loaddata(burgLayer);

    this.wmslayerList.push(burgLayer);
    // this.getBoundary();
  }

  private addImageLayer(lyr: any): void {
    const layer =
      lyr.name === 'border'
        ? new ImageLayer({
          ...lyr,
          visible: lyr.visible,
          zIndex: 0,
          source: new ImageWMS({
            url: wmsurl,
            params: {
              LAYERS: workspace + ':' + lyr.name,
              VIEWPARAMS: this.viewparam,
              TRANSPARENT: false,
              BGCOLOR: '0x183d5c',
            },
            ratio: 1,
            serverType: 'geoserver',
          }),
        })
        : new ImageLayer({
          ...lyr,
          visible: lyr.visible,
          source: new ImageWMS({
            url: wmsurl,
            params: {
              LAYERS: workspace + ':' + lyr.name,
              VIEWPARAMS: this.viewparam,
            },
            ratio: 1,
            serverType: 'geoserver',
          }),
        });
    this.wmslayerList.push(layer);
    // this.getBoundary();
  }

  /** Show the map's baked terrain, if it has any, in place of the GeoServer
   * images, as the other map pages do (see mountTerrain). */
  private addTerrain(): void {
    const mapId = this.mapid;
    clearTimeout(this.terrainWaitTimer);
    this.dataService.getTerrainInfo(mapId).subscribe({
      next: (info: TerrainInfo) => {
        if (this.mapid !== mapId || !this.map) return;
        if (info?.ground) this.view = applyGround(this.map, info.ground); // the map's own zoom ladder
        if (isTerrainReady(info)) {
          this.mountTerrainFor(mapId, info);
        } else if (info?.status === 'baking') {
          // a new map: say so, and switch to the terrain once it's ready
          // (same as MapService does on the other map pages)
          this.terrainNotice = addTerrainPaintingNotice(this.map);
          this.waitForTerrain(mapId);
        }
      },
      error: () => {
        // no terrain service: keep the GeoServer look
      },
    });
  }

  private mountTerrainFor(mapId: string, info: TerrainInfo): void {
    this.terrainTowns?.destroy();
    this.terrainClimateBars?.destroy();
    const mount = mountTerrain(this.map, info, serviceurl, () => this.mapid === mapId, { data: this.dataService, mapId });
    this.terrainTowns = mount.towns;
    this.terrainClimateBars = mount.climateBars;
    this.hasTerrain = true;
    this.cdr.detectChanges();
  }

  /** Checks every 30s while a new map's terrain is being made, then shows it. */
  private waitForTerrain(mapId: string): void {
    clearTimeout(this.terrainWaitTimer);
    this.terrainWaitTimer = setTimeout(() => {
      if (this.mapid !== mapId || !this.map) return; // left this map
      this.dataService.getTerrainInfo(mapId).subscribe({
        next: (info: TerrainInfo) => {
          if (this.mapid !== mapId || !this.map) return;
          if (info?.status === 'baking') {
            this.waitForTerrain(mapId);
            return;
          }
          if (this.terrainNotice) this.map.removeControl(this.terrainNotice);
          this.terrainNotice = null;
          if (isTerrainReady(info)) this.mountTerrainFor(mapId, info);
        },
        error: () => this.waitForTerrain(mapId),
      });
    }, 30000);
  }

  ngOnDestroy(): void {
    clearTimeout(this.terrainWaitTimer); // stop checking once the page is left
  }

  getBoundary(redirect_coords?: string) {
    const cityVisitZoom = sessionStorage.getItem('cityVisitZoom')
    const cityVisitLon = sessionStorage.getItem('cityVisitLon')
    const cityVisitLat = sessionStorage.getItem('cityVisitLat')
    if (cityVisitZoom && cityVisitLon && cityVisitLat) {
      this.map.getView().setCenter([Number(cityVisitLon), Number(cityVisitLat)])
      this.map.getView().setZoom(Number(cityVisitZoom))
      sessionStorage.removeItem('cityVisitZoom')
      sessionStorage.removeItem('cityVisitLon')
      sessionStorage.removeItem('cityVisitLat')
      return
    }
    this.DataService.getboundaryData(this.mapid).subscribe((data: any) => {
      this.cdr.detectChanges();
      const features = data.features;
      this.borderCropFeat = new GeoJSON().readFeature(features[0]);
      const contentZoom = sessionStorage.getItem('contentCreationZoom')

      if ((!contentZoom && !redirect_coords)) {
        this.map.getView().fit(this.borderCropFeat.getGeometry().getExtent(), {
          maxZoom: overview(3, groundOf(this.map)),
          duration: 500,
        });
      }
      else {
        this.map.getView().setZoom(Number(contentZoom))
        sessionStorage.removeItem('contentCreationZoom')
      }
      const contentLat = sessionStorage.getItem('contentCreationLat')
      const contentLon = sessionStorage.getItem('contentCreationLon')
      if (contentLat && contentLon) {
        this.map.getView().setCenter([Number(contentLon), Number(contentLat)])
        sessionStorage.removeItem('contentCreationLat')
        sessionStorage.removeItem('contentCreationLon')
      }
      this.layerlist.forEach((lyr: any) => {
        this.map.getLayers().forEach((maplyr: any) => {
          if (maplyr.get('name') === lyr.name && lyr.name == 'rivers') {
            if (lyr['crop']) {
              maplyr.removeFilter(lyr['crop']);
              lyr['crop'].set('active', false);
            }
            lyr['feature'] = this.borderCropFeat;
            if (lyr.name == 'boundary') {
              lyr['crop'] = new Crop({
                feature: lyr['feature'],
                wrapX: true,
                inner: false,
                shadowWidth: 0,
              });
            } else {
              lyr['crop'] = new Crop({
                feature: lyr['feature'],
                wrapX: true,
                inner: false,
                shadowWidth: 0,
              });
              lyr['crop'].set('active', true);
              maplyr.addFilter(lyr['crop']);
            }
          }
        });
      });
    });
  }
  addFogLayer() {
    this.draw = new Draw({
      source: this.vectorSorce,
      type: 'Point',
    });
    this.drawenabled = true;
    this.draw.on('drawstart', (evt: any) => {
      const sketch = evt.feature;
      sketch.getGeometry().on('change', (evt: any) => {
        const geom = evt.target;
        this.setFilter(geom.getCoordinates());
      });
    });
    this.draw.on('drawend', (evt: any) => {
      this.map.removeInteraction(this.draw);
      this.drawenabled = false;
      this.setFilter(evt.feature.getGeometry().getCoordinates());
    });
    this.map.addInteraction(this.draw);
    // this.changeHandler(newlayerlist)
  }
  getSelection(item: any) {
    return item.checked == true;
  }

  removeCityLayer() {
    if (this.map1) {
      this.map1.removeLayer(this.cityVectorLayer);
    }
    this.isdisplay_city = false;
    this.cdr.detectChanges();
  }

  changeToggleLayer(item: any) {
    // each layer toggles independently, so a bare map plus any combination of
    // overlays can be shown at once, rather than exactly one at a time
    item.checked = !item.checked;
    const currentLayer = this.newLayers.find((lyr) => lyr.checked === true);
    if (currentLayer) {
      rememberMapLayer(this.mapid, currentLayer.name);
      this.currentLayerName = currentLayer.name;
      this.currentLayerWikiName = currentLayer.label?.toLowerCase();
      this.getLegendDataLocal(this.mapid, currentLayer.name);
    }
    this.filterAndToggleLayers(this.newLayers);
  }

  filterAndToggleLayers(layers: any): void {
    const activeLayers = layers.filter((lyr) => lyr.checked);
    let activeLayerNames = activeLayers.map((lyr) => lyr.name);
    activeLayerNames = [...this.arrayOfLayerNames, ...activeLayerNames];
    const mapLayers = this.map.getLayers().getArray();

    this.layerlist.forEach((layer) => {
      layer.checked = activeLayerNames.includes(layer.name);
      const targetLayer = mapLayers.find(
        (lyr) => lyr.get('name') === layer.name || lyr.get('name') === 'burgs'
      );
      if (targetLayer) {
        targetLayer.setVisible(!!layer.checked);
      }
    });
    if (this.hasTerrain) applyTerrainLook(this.map);
  }

  toggleCityMapDetails() {
    this.sideInfoBar = true;
    this.isCityDetailsVisible = !this.isCityDetailsVisible;
    this.cdr.detectChanges();
    return this.sideInfoBar;
  }
  changeHandler(item: any) {
    this.layerlist.forEach((layer) => {
      if (layer.name === item.name) {
        layer.checked = !item.checked;
        this.map.getLayers().forEach((lyr) => {
          if (item.name == lyr.get('name')) {
            lyr.setVisible(layer.checked);
          }
        });
      }
    });
    if (this.hasTerrain) applyTerrainLook(this.map);
  }
  setFilter(coordinates: any) {

    this.layerlist.forEach((lyr: any) => {
      if (lyr.radius > 0) {
        this.map.getLayers().forEach((maplyr: any) => {
          if (maplyr.get('name') === lyr.name) {
            if (lyr['crop']) {
              maplyr.removeFilter(lyr['crop']);
              lyr['crop'].set('active', false);
            }
            if (lyr['feature'] == this.borderCropFeat) {
              lyr['feature'] = undefined;
            }
            lyr['feature'] = new Feature(
              this.getPolygon(
                lyr.radius,
                coordinates,
                lyr['feature'] ? lyr['feature'] : undefined
              )
            );
            lyr['crop'] = new Crop({
              feature: lyr['feature'],
              wrapX: true,
              inner: false,
              shadowWidth: 0,
            });
            lyr['crop'].set('active', true);
            maplyr.addFilter(lyr['crop']);
          }
        });
      }
    });
    this.fogTerrain(coordinates);
    //this.addfoglayers();
  }

  /** Baked terrain is fogged like the GeoServer images it replaces: the
   * terrain by the terrain_view radius, borders and place names by the state one. */
  private fogTerrain(coordinates: any): void {
    const radiusOf = (name: string) => this.layerlist.find((l: any) => l.name === name)?.radius || 0;
    const fogged: Record<string, number> = {
      terrain: radiusOf('terrain_view'),
      terrain_borders: radiusOf('state'),
      terrain_labels: radiusOf('state'), // names would give away undiscovered realms
      map_markers: radiusOf('state'), // and so would markers
      terrain_temperature: radiusOf('terrain_view'), // climate would outline unknown land
      terrain_rainfall: radiusOf('terrain_view'),
      terrain_towns: radiusOf('terrain_view'), // town plans too
      terrain_canopy: radiusOf('terrain_view'), // battle-map tree crowns, over the land
    };
    this.map.getLayers().forEach((maplyr: any) => {
      const radius = fogged[maplyr.get('name')];
      if (!radius) return;
      const old = maplyr.get('fogCrop');
      if (old) maplyr.removeFilter(old);
      const area = new Feature(this.getPolygon(radius, coordinates, undefined));
      // decluttered names escape the crop: hide those outside the fog as well
      if (maplyr.get('name') === 'terrain_labels') setLabelsFogArea(maplyr, area.getGeometry() || null);
      const crop = new Crop({
        feature: area,
        wrapX: true,
        inner: false,
        shadowWidth: 0,
      });
      crop.set('active', true);
      maplyr.addFilter(crop);
      maplyr.set('fogCrop', crop);
    });
  }
  getPolygon(radius: any, coordinates: any, feat: any) {
    radius = radius > 0 ? radius * 100 : 1;
    var newoptions: any = {
      steps: 100,
      units: 'kilometers',
      properties: { foo: 'bar' },
    };
    var circles: any = turf.circle(coordinates, radius, newoptions);
    var uniongeom: any;
    if (feat) {
      const newfeat = turf.multiPolygon(feat.getGeometry().getCoordinates());
      const newcircle = turf.multiPolygon([circles.geometry.coordinates]);
      uniongeom = turf.union(turf.featureCollection([newfeat, newcircle]));
    }
    var uniongeometry: any;
    if (uniongeom) {
      uniongeometry =
        uniongeom.geometry.type == 'Polygon'
          ? new MultiPolygon([uniongeom.geometry.coordinates])
          : new MultiPolygon(uniongeom.geometry.coordinates);
    }
    return uniongeom
      ? uniongeometry
      : new MultiPolygon([circles.geometry.coordinates]);
  }
  getPolygonall(radius: any) {
    var uniongeom: any;
    radius = radius * 100;
    var newoptions: any = {
      steps: 100,
      units: 'kilometers',
      properties: { foo: 'bar' },
    };
    var i = 0;
    this.vectorSorce.forEachFeature((feat: any) => {
      var circle: any = turf.circle(
        feat.getGeometry().getCoordinates(),
        radius,
        newoptions
      );

      if (i == 0) {
        uniongeom = circle;
      } else {
        uniongeom = turf.union(turf.featureCollection([uniongeom, circle]));
      }
      i++;
    });
    return this.vectorSorce.getFeatures().length == 1
      ? new MultiPolygon([uniongeom.geometry.coordinates])
      : new MultiPolygon(uniongeom.geometry.coordinates);
  }
  rangeChange(item: any) {
    if (this.vectorSorce.getFeatures().length > 0) {
      this.layerlist.forEach((lyr: any) => {
        if (lyr.radius >= 0 && item.name == lyr.name) {
          lyr.range = item.range;
          this.map.getLayers().forEach((maplyr: any) => {
            if (maplyr.get('name') === lyr.name) {
              if (lyr['crop']) {
                maplyr.removeFilter(lyr['crop']);
                lyr['crop'].set('active', false);
              }
              lyr['feature'] = new Feature(this.getPolygonall(item.radius));
              lyr['crop'] = new Crop({
                feature: lyr['feature'],
                wrapX: true,
                inner: false,
                shadowWidth: 0,
              });
              lyr['crop'].set('active', true);
              maplyr.addFilter(lyr['crop']);
            }
          });
        }
      });
      const vectfeats = this.vectorSorce.getFeatures();
      if (vectfeats.length > 0) {
        // this.removefoglayer();
      }
    }
  }

  filterlayers(layers) {
    this.newLayers = layers.filter((lyr) => lyr.toggle == true);
    return this.newLayers;
  }

  //////////////////////////////////////////////////////////////
  citydataload(cityid: any) {
    this.DataService.getCityData(this.mapid, cityid).subscribe((data: any) => {
      const citydata = data.res;
      this.loadcitymap(citydata);
      this.cdr.detectChanges();
    });
  }
  loadcitymap(citydata) {
    if (!this.map1) {
      this.map1 = new Map({
        target: 'map1',
        layers: [],
        view: (this.view = new View({
          projection: 'EPSG:3857',
          zoom: 3,
          minZoom: 3,
          maxZoom: 20,
          // constrainResolution: true,
        })),
        controls: defaultcontrol({
          attribution: false,
          // zoom: false,
        }),
      });
    }
    this.cityvectorSorce = new VectorSource();
    this.cityVectorLayer = new VectorLayer({
      source: this.cityvectorSorce,
      style: (e, resolution) => {
        return this.cityFeatureStyle(
          e,
          resolution,
          this.map1.getView().getZoom()
        );
      },
    });
    this.map1.addLayer(this.cityVectorLayer);

    const newfeatures = [];

    citydata.features.forEach((element) => {
      if (element.type == 'Feature' && element.id == 'values') {
      } else if (element.type == 'Feature' && element.id != 'values') {
        const feature = new GeoJSON().readFeature(element);

        newfeatures.push([feature]);
      } else if (element.type == 'GeometryCollection') {
        element.geometries.forEach((newgeom) => {
          const obj = {
            type: 'Feature',
            id: element.id,
            properties: newgeom,
            geometry: {
              type: newgeom.type,
              coordinates: newgeom.coordinates,
            },
          };
          newfeatures.push(new GeoJSON().readFeature(obj));
        });
      } else {
        const obj = {
          type: 'Feature',
          id: element.id,
          properties: { element },
          geometry: {
            type: element.type,
            coordinates: element.coordinates,
          },
        };
        newfeatures.push(new GeoJSON().readFeature(obj));
      }
    });

    this.cityvectorSorce.clear();

    this.cityvectorSorce.addFeatures(newfeatures);
    this.map1.getView().fit(this.cityvectorSorce.getExtent());
  }

  cityFeatureStyle(feature, resolution, zoom) {
    const properties = feature.getProperties();

    var style;
    if (feature.id_ == 'water') {
      style = [
        new Style({
          fill: new Fill({
            color: '#85BCB2',
          }),
        }),
      ];
    } else if (feature.id_ == 'buildings') {
      style = [
        new Style({
          fill: new Fill({
            color: '#D6A36E',
          }),
          stroke: new Stroke({
            color: '#ccc5b8',
            width: 1,
          }),
        }),
      ];
    } else if (feature.id_ == 'fields') {
      var img = new Image();
      img.src = 'assets/green.png'; // your image here

      style = [
        new Style({
          fill: new Fill({
            // color:pattern
            color: '#99AA77',
          }),
          stroke: new Stroke({
            color: '#99AA77',
            width: 1,
          }),
        }),
      ];
    } else if (feature.id_ == 'squares') {
      style = [
        new Style({
          fill: new Fill({
            color: '#6B645F',
          }),
          stroke: new Stroke({
            color: '#99AA77',
            width: 1,
          }),
        }),
      ];
    } else if (feature.id_ == 'earth') {
      style = [
        new Style({
          fill: new Fill({
            color: '#FFF2C8',
          }),
          stroke: new Stroke({
            color: '#99AA77',
            width: 1,
          }),
        }),
      ];
    } else if (feature.id_ == 'trees') {
      var size = 1;
      if (zoom < 12) {
        size = 1;
      } else if (zoom > 12 && zoom <= 14) {
        size = 2;
      } else {
        size = 5;
      }
      style = new Style({
        image: new CircleStyle({
          radius: zoom > 15 ? 5 : 2,
          fill: new Fill({
            color: '#667755',
          }),
        }),
      });
    } else if (feature.id_ == 'road') {
      var size = 1;
      if (parseInt(resolution) > 12) {
        size = 1;
      } else if (parseInt(resolution) > 9 && parseInt(resolution) <= 12) {
        size = 2;
      } else if (parseInt(resolution) > 7 && parseInt(resolution) <= 9) {
        size = 3;
      } else if (parseInt(resolution) > 5 && parseInt(resolution) <= 7) {
        size = 4;
      } else if (parseInt(resolution) > 4 && parseInt(resolution) <= 5) {
        size = 4;
      } else if (parseInt(resolution) > 3 && parseInt(resolution) <= 4) {
        size = 5;
      } else if (parseInt(resolution) > 2 && parseInt(resolution) <= 3) {
        size = 5;
      } else if (parseInt(resolution) > 1 && parseInt(resolution) <= 2) {
        size = 5;
      } else if (parseInt(resolution) > 0 && parseInt(resolution) <= 1) {
        size = 5;
      }
      style = [
        new Style({
          fill: new Fill({
            color: '#ccc5b8',
          }),
        }),
        new Style({
          fill: new Fill({
            color: '#ccc5b8',
          }),
          stroke: new Stroke({
            color: '#ccc5b8',
            width: size,
          }),
        }),
      ];
    } else if (feature.id_ == 'rivers') {
      var size = 3;
      if (parseInt(resolution) > 12) {
        size = 5;
      } else if (parseInt(resolution) > 9 && parseInt(resolution) <= 12) {
        size = 10;
      } else if (parseInt(resolution) > 7 && parseInt(resolution) <= 9) {
        size = 12;
      } else if (parseInt(resolution) > 5 && parseInt(resolution) <= 7) {
        size = 15;
      } else if (parseInt(resolution) > 4 && parseInt(resolution) <= 5) {
        size = 20;
      } else if (parseInt(resolution) > 3 && parseInt(resolution) <= 4) {
        size = 25;
      } else if (parseInt(resolution) > 2 && parseInt(resolution) <= 3) {
        size = 30;
      } else if (parseInt(resolution) > 1 && parseInt(resolution) <= 2) {
        size = 35;
      } else if (parseInt(resolution) > 0 && parseInt(resolution) <= 1) {
        size = 40;
      }

      style = [
        new Style({
          fill: new Fill({
            color: '#85BCB2',
          }),
          stroke: new Stroke({
            color: '#85BCB2',
            width: size,
            //width:25,
          }),
        }),
      ];
    } else if (properties.type == 'fields') {
      style = new Style({
        fill: new Fill({
          color: '#ccc5b8',
        }),
        stroke: new Stroke({
          color: '#1a1917',
          width: 1,
        }),
      });
    } else if (
      properties.type == 'fields' ||
      properties.type == 'Squares' ||
      properties.type == 'Prisms' ||
      properties.type == 'Walls' ||
      properties.type == 'Earth' ||
      properties.type == 'Districts'
    ) {
      style = new Style({
        stroke: new Stroke({
          color: '#1a1917',
          width: 1,
        }),
      });
    } else {
      style = new Style({
        stroke: new Stroke({
          color: '#1a1917',
        }),
      });
    }
    return style;
  }

  getMapData() {
    this.layerlist.forEach((lyr) => {
      if (lyr.name == 'state') {
        var source = new VectorSource();
        var layer = new VectorLayer({
          properties: lyr,
          opacity: lyr.opacity,
          source: source,
          style: (feature) => {
            return mapstyle(feature, lyr.style);
          },
        });

        this.vectorlayerList.push(layer);
        this.map.addLayer(layer);
      }
    });

    this.vectorlayerList.forEach((lyr) => {
      const properties = lyr.getProperties();
      //if(properties.name != 'foglayer' && properties.name != 'grid'){
      if (properties.name == 'state') {
        this.loaddata(lyr);
      }
    });
  }
  loaddata(layer) {
    const properties = layer.getProperties();
    this.DataService.getMapData(properties.servicename, this.mapid).subscribe(
      (data: any) => {
        var features = [];
        const format = new WKT();
        data.res.forEach((feat) => {
          var feature = format.readFeature(
            feat.geom.split(';')[1].replace(' ', '')
          );
          feature.setProperties(feat);
          features.push(feature);
        });
        layer.getSource().addFeatures(features);
      
          this.cdr.detectChanges();}
    );
  }

  toggleCultureList() {
    this.isCultureVisible = !this.isCultureVisible;
    this.cdr.detectChanges();
  }

  toggleMapDetails() {
    this.sideInfoBar = true;
    this.isMapDetailsVisible = !this.isMapDetailsVisible;
    this.cdr.detectChanges();
    return this.sideInfoBar;
  }

  addMarker() {
    this.markers?.startAdding();
  }

  /** Save the current view as a picture at twice the screen size. */
  exportPicture() {
    if (!this.hasTerrain || this.exportingPicture) return;
    this.exportingPicture = true;
    const name = (this.map_name || this.mapid || 'map').toString().replace(/[^\w-]+/g, '_');
    exportMapImage(this.map, name + '.png', 2)
      .catch((err) => this.toastService.showNote('Could not save the map picture: ' + (err?.message || err), 'warning'))
      .finally(() => {
        this.exportingPicture = false;
        this.cdr.detectChanges();
      });
  }

  zoomIn() {
    const view = this.map.getView();
    const zoom = view.getZoom();
    view.setZoom(zoom + 1);
  }
  zoomOut() {
    const view = this.map.getView();
    const zoom = view.getZoom();
    view.setZoom(zoom - 1);
  }

  navigateToCityNameWiki() {
    this.wikiService.openCityWiki(this.cityData['City Name'], this.mapid, this.map_name);
  }

  onDynamicDataClick(dataName: string) {

    this.wikiService.openWiki(this.currentLayerWikiName, dataName, this.mapid, this.map_name);
  }

  navigateToWikiWorld(map_name?: string) {
    this.wikiService.openMapWiki(this.mapid, map_name || this.map_name);
  }

  isResourceField(key: string | any): boolean {
    const resourceKeys = [
      'Natural Resources',
      'Bonus Resources',
      'Farm Resources',
      'Mineral Resources',
      'Special Resources',
    ];
    return resourceKeys.includes(key);
  }

  hoveredResource: any = null;
  tooltipStyle: any = {};

  showResourceTooltip(event: MouseEvent, item: any): void {
    if (!item) return;
    this.hoveredResource = typeof item === 'string' ? { name: item } : item;
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const rect = target.getBoundingClientRect();
      const tooltipWidth = 330;
      const left = Math.max(10, rect.left - tooltipWidth - 15);
      const top = Math.max(10, Math.min(window.innerHeight - 240, rect.top - 20));
      this.tooltipStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }

  hideResourceTooltip(): void {
    this.hoveredResource = null;
  }

  splitResources(value: string | any): any[] {
    if (!value || value === 'None') return [];
    if (Array.isArray(value)) {
      return value.map((item) => {
        if (typeof item === 'string') {
          return { name: item, description: '', production: 0, economy: 0, rarity: 0, processing: 0 };
        }
        return item;
      });
    }
    if (typeof value === 'string') {
      if (value.toLowerCase() === 'none') return [];
      return value.split(',').map((v) => ({
        name: v.trim(),
        description: '',
        production: 0,
        economy: 0,
        rarity: 0,
        processing: 0
      }));
    }
    return [];
  }

  onResourceClick(resource: string): void {
    this.wikiService.openResourceWiki(resource);
  }

  isLinkField(key: string | any): boolean {
    const linkKeys = ['State', 'Province', 'Culture', 'Religion', 'Biome'];
    return linkKeys.includes(key);
  }

  navigateToDynamicLink(key: string | any, value: string | any): void {
    this.wikiService.openWiki(key, value, this.mapid, this.map_name);
  }
  navigateToElevationLink() {
    const url = `${WORLD_TUMBLER_URL}/elevations/elevations`;
    window.open(url, '_blank');
  }
  zoomToRedirectCoordsMain(redirect_coords: string) {


    if (!redirect_coords) return;

    const parts = redirect_coords.split(',').map(Number);
    if (parts.length !== 2 || parts.some(isNaN)) {
      console.warn('Invalid coordinate string:', redirect_coords);
      return;
    }
    const [lon, lat] = parts;
    setTimeout(() => {
      this.map.getView().setCenter([lon, lat]);
      this.map.getView().setZoom(ground(18));
    }, 1000);
  }

  browseWpStore() {
    // Opens the store filtered to this map's genre. The StoreLinkService
    // opens the in-app store.
    this.showMenu = false;
    this.dataService.getMapGenre(this.mapid).subscribe((data: any) => {
      if (data?.res) {
        const actualGenre = data.res
        this.storeLinks.openStore({ genre: actualGenre });
      }
      else {
        this.storeLinks.openStore();
      }
      this.cdr.detectChanges();
    }, () => {
      this.storeLinks.openStore();
      this.cdr.detectChanges();
    });
  }

  constructParam(genre: string) {
    const groupGenre = ['Science Fiction & Science Fantasy (Traveller, etc)', 'Modern & Horror (Call of Cthulhu, etc)', 'Fantasy (Dungeons & Dragons, etc)', 'Fantasy (Dungeons & Dragons, etc)']
    const paramsGenre = ['scifi', 'modern-horror', 'fantasy']
    const index = groupGenre.indexOf(genre);
    if (index !== -1) {
      return paramsGenre[index];
    }
    return '';
  }
}
